import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { RestoreConnectionArgs } from '../../../Domain/Tools/Services';
import { toolsServices } from '../../../Domain/Tools/Services';

const mutationFn = (data: RestoreConnectionArgs) => {
  return toolsServices.restoreConnection(data);
};

export const useRestoreConnectionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, RestoreConnectionArgs>(mutationFn, {
    onSuccess: () => {
      // Invalidate the deleted connections query to refresh the list
      queryClient.invalidateQueries(['getDeletedConnections']);
    },
  });
};
